import { render, staticRenderFns } from "./CampanhaPasso3.vue?vue&type=template&id=640ec548"
import script from "./CampanhaPasso3.vue?vue&type=script&lang=js"
export * from "./CampanhaPasso3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports